<template>
    <span v-if="field.type === 'HIGHLIGHT'" v-html="data.source[field.name]"></span>
    <pretty-date-time v-else-if="field.type === 'DATETIME' || field.type === 'DATE' || field.type === 'TIME'"
                      :value="data.source[field.name]" :format="field.dateFormat" :value-format="field.dateValueFormat"
                      java-format></pretty-date-time>
    <span v-else-if="field.displayType === 'LINK'">
        <a v-if="data.source[field.name]" :href="data.source[field.name]" target="_blank" style="color: #2A9CFF">打开链接</a>
    </span>
    <span v-else>{{displayValue}}</span>
</template>

<script>
    export default {
        name: "NewsField",
        props: {
            data: Object,
            field: Object
        },
        computed: {
            displayValue(){
                const value = this.data.source[this.field.name]
                if(value === null || value === undefined){
                    return ''
                }
                if(this.field.type === 'BOOLEAN'){
                    if(Array.isArray(value)){
                        return value.map(item => item?'是':'否').join(",")
                    }else{
                        return value?'是':'否'
                    }
                }else{
                    if(Array.isArray(value)){
                        return value.join(",")
                    }else{
                        return value
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
